import { CartItem } from "../../models/cart-item";
import { ActionTypes } from "../actions/types.ts";

export interface cartState {
  items: CartItem[];
  totalAmount: number;
}

const initialState: cartState = {
  items: [],
  totalAmount: 0,
};

const cartReducer = (
  state: cartState = initialState,
  action: {
    type: string;
    payload?: CartItem | number | string | { id: string; quantity: number };
  },
) => {
  switch (action.type) {
    case ActionTypes.ADD_ITEM:
      const newItem = action.payload as CartItem;
      const existingItemIndex = state.items.findIndex(
        (item) => item.id === newItem.id,
      );
      if (existingItemIndex >= 0) {
        const updatedItems = [...state.items];
        updatedItems[existingItemIndex].quantity += newItem.quantity;
        return {
          ...state,
          items: updatedItems,
          totalAmount:
            state.totalAmount + newItem.productPrice * newItem.quantity,
        };
      }
      return {
        ...state,
        items: [...state.items, newItem],
        totalAmount:
          state.totalAmount + newItem.productPrice * newItem.quantity,
      };
    case ActionTypes.REMOVE_ITEM:
      const itemId = action.payload as string;
      const itemToRemoveIndex = state.items.findIndex(
        (item) => item.id === itemId,
      );
      if (itemToRemoveIndex >= 0) {
        const updatedItems = [...state.items];
        const removedItem = updatedItems[itemToRemoveIndex];
        updatedItems.splice(itemToRemoveIndex, 1);
        return {
          ...state,
          items: updatedItems,
          totalAmount:
            state.totalAmount - removedItem.productPrice * removedItem.quantity,
        };
      }
      return state;
    case ActionTypes.UPDATE_ITEM_QUANTITY:
      const { id, quantity } = action.payload as {
        id: string;
        quantity: number;
      };
      if (quantity >= 1) {
        const itemIndex = state.items.findIndex((item) => item.id === id);
        const updatedItems = [...state.items];
        const itemToUpdate = updatedItems[itemIndex];
        const priceDifference =
          (quantity - itemToUpdate.quantity) * itemToUpdate.productPrice;
        updatedItems[itemIndex].quantity = quantity;
        return {
          ...state,
          items: updatedItems,
          totalAmount: state.totalAmount + priceDifference,
        };
      }
      return state;
    case ActionTypes.CLEAR_CART:
      return {
        ...state,
        items: [],
        totalAmount: 0,
      };
    default:
      return state;
  }
};

export default cartReducer;
